<template>
  <div class="addcurrency">
    <el-row class="rows">
      <el-col :span="2">
        <div class="grid-content bg-purple">选择币种</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-light">
          <el-select v-model="coin" placeholder="请选择" class="elSelect">
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.currency"
              :value="item.currency"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row class="rows">
      <el-col :span="2">
        <div class="grid-content bg-purple">链名称</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-light">
          <el-radio-group v-model="radioName">
            <el-radio
              :label="item.link"
              v-for="(item, index) in chainName"
              :key="index"
            ></el-radio>
          </el-radio-group>
        </div>
      </el-col>
    </el-row>
    <el-row class="rows">
      <el-col :span="2">
        <div class="grid-content bg-purple">钱包地址</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-light">
          <el-input v-model="address" placeholder="请输入钱包地址"></el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <div class="btnBox">
          <el-button type="primary" class="add-btn" @click="onAddCurrency"
            >提交</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div></div>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default { 
        name: "addcurrency",
        data() {
            return {
                currencyList: [],
                address: "",
                radioName: "",
                chainName: [], 
                coin: "",
            };
        },
        computed: {
            ...mapGetters(["userInfo"]),
        },
        created() {
            this.listDigitPayWays();
        },
        methods: {
            // 数字货币列表
            listDigitPayWays() {
                let that = this;
                that.$http.post(that.$api.listDigitPayWays).then((res) => {
                    if (res.code == 0) {
                        if (res.data.length > 0) {
                            that.currencyList = res.data;
                            that.chainName = res.data[0].addrtype;
                        }
                    }
                });
            },
            onAddCurrency() {
                if (!this.coin) {
                    this.$message({
                        message: "请选择币种",
                        type: "warning",
                    });
                    return;
                }
                if (!this.radioName) {
                    this.$message({
                        message: "请选择链名称",
                        type: "warning",
                    });
                    return;
                }
                if (!this.address) {
                    this.$message({
                        message: "请输入钱包地址",
                        type: "warning",
                    });
                    return;
                }
                let option = {
                    branch: this.radioName, //	链路
                    memberId: this.userInfo.userId, //	会员id
                    name: this.coin, //	币种
                    number: this.address, //钱包地址
                    clientItem: window.childCode, //子平台id字段
                    type: 1,
                };
                this.$http.post(this.$api.addbank, option, true).then((res) => {
                    if (res.code == 0) {
                        this.$nkhttp.getBank();
                        this.$message({
                            message: "添加成功",
                            type: "success",
                        });
                    }
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
.addcurrency {
  margin: 40px 65px;
  .grid-content {
    font-size: 15px;
    line-height: 40px;
  }
  .rows {
    margin-bottom: 30px;
  }
  .btnBox {
    text-align: center;
    .add-btn {
      width: 50%;
      background: #333;
      border: none;
    }
  }
  .elSelect {
    width: 100%;
  }
}
</style>